import {
    createSelector,
} from '@reduxjs/toolkit';

import { POKER_BLAST_WIDGET } from '~spa/Components/PokerBlastWidget/constants';

import {
    selectRestrictedApps,
} from './userSelectors';

import {
    selectBrandId,
    selectIsIosApp,
    selectIsAndroidApp,
    selectPokerBlastConfig,
} from './clientStateSelectors';

export const selectIsPokerBlastAvailable = createSelector(
    selectPokerBlastConfig,
    selectBrandId,
    selectRestrictedApps,
    selectIsAndroidApp,
    selectIsIosApp,
    (config, brandId, restrictedApps, isAndroidApp, isIosApp) => {
        const {
            brands_blacklist,
            disabled_on_android,
            disabled_on_ios,
        } = config;

        if (brands_blacklist.includes(brandId)) {
            return false;
        }

        if (restrictedApps.includes(POKER_BLAST_WIDGET)) {
            return false;
        }

        if (isAndroidApp && disabled_on_android) {
            return false;
        }

        if (isIosApp && disabled_on_ios) {
            return false;
        }

        return true;
    }
);
